import React from 'react';
import { Star } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    id: 1,
    name: 'John Mutesa',
    role: 'Business Owner',
    content: 'The business registration process used to take weeks. Now I can register my business in just a few days. This platform has saved me so much time!',
    rating: 5
  }, {
    id: 2,
    name: 'Marie Uwase',
    role: 'Citizen',
    content: 'Getting my national ID used to be a hassle. With the e-Services portal, I applied online and received it within a week. The process was smooth and efficient.',
    rating: 5
  }, {
    id: 3,
    name: 'James Karemera',
    role: 'Student',
    content: 'As a student applying for various certificates and documents, this platform has been a lifesaver. No more long queues and multiple office visits.',
    rating: 4
  }];
  return <section className="py-16 bg-white" data-id="element-267">
      <div className="container mx-auto px-4" data-id="element-268">
        <div className="text-center mb-12" data-id="element-269">
          <h2 className="text-3xl font-bold mb-4" data-id="element-270">What People Say</h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-271">
            Hear from citizens and businesses who have experienced the
            convenience of our e-government services.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-272">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-gray-50 p-6 rounded-lg" data-id="element-273">
              <div className="flex mb-4" data-id="element-274">
                {[...Array(5)].map((_, i) => <Star key={i} className={`h-5 w-5 ${i < testimonial.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-275" />)}
              </div>
              <p className="text-gray-700 mb-6" data-id="element-276">"{testimonial.content}"</p>
              <div data-id="element-277">
                <p className="font-semibold" data-id="element-278">{testimonial.name}</p>
                <p className="text-gray-500 text-sm" data-id="element-279">{testimonial.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};